import React from "react";
import { FiX, FiMessageSquare, FiRefreshCw, FiMail, FiEdit, FiTrello, FiClock, FiBell, FiFileText, FiAward, FiHardDrive, FiBriefcase, FiAlertCircle } from "react-icons/fi";
import { celPowiadomienia, BRAK_CELU_PODPOWIEDZ } from "../../utils/notificationTarget";
import styles from "./NotificationItem.module.css";

const ICON_MAP = {
    FiMessageSquare: <FiMessageSquare />,
    FiRefreshCw: <FiRefreshCw />,
    FiMail: <FiMail />,
    FiEdit: <FiEdit />,
    FiTrello: <FiTrello />,
    FiClock: <FiClock />,
    FiBell: <FiBell />,
    FiFileText: <FiFileText />,
    FiAward: <FiAward />,
    FiHardDrive: <FiHardDrive />,
    FiBriefcase: <FiBriefcase />,
    FiAlertCircle: <FiAlertCircle />,
};

const CATEGORY_COLOR = {
    "Zgłoszenia": "#3B82F6",
    "Kanban": "#8B5CF6",
    "Komunikacja": "#F59E0B",
    "Dostępy": "#10B981",
    "HR": "#EC4899",
    "System": "#EF4444",
};

function timeAgo(dateStr) {
    const now = new Date();
    const date = new Date(dateStr);
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return "przed chwilą";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min temu`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h temu`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} dn. temu`;
    return date.toLocaleDateString("pl-PL", { day: "numeric", month: "short" });
}

const NotificationItem = ({ notification, onRead, onDelete, onNavigate }) => {
    const icon = ICON_MAP[notification.typeIcon] || <FiBell />;
    const color = CATEGORY_COLOR[notification.typeCategory] || "#6B7280";

    /* [OBSZAR B 2026-09-03, poz. 3c/3d] Cel liczy JEDEN wspólny moduł — ten sam co w centrum
       powiadomień. Dotąd dzwonek nawigował wprost pod zapisany link, więc powiadomienie bez linku
       udawało przycisk (kursor „łapka", role="button"), a klik nie robił nic. */
    const cel = celPowiadomienia(notification);

    const handleClick = () => {
        if (!notification.isRead) {
            onRead(notification.id);
        }
        if (cel) {
            onNavigate(cel);
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete(notification.id);
    };

    return (
        <div
            className={`${styles.item} ${!notification.isRead ? styles.unread : ""} ${cel ? "" : styles.itemBezCelu}`}
            onClick={handleClick}
            role={cel ? "button" : undefined}
            tabIndex={cel ? 0 : undefined}
            title={cel ? undefined : BRAK_CELU_PODPOWIEDZ}
            style={{ "--notif-accent": color }}
        >
            <div className={styles.iconWrap} style={{ color, background: `${color}12` }}>
                {icon}
            </div>
            <div className={styles.content}>
                <div className={styles.title}>{notification.title}</div>
                <div className={styles.message}>{notification.message}</div>
                <div className={styles.meta}>
                    <span className={styles.time}>{timeAgo(notification.createdAt)}</span>
                    <span className={styles.category} style={{ color }}>{notification.typeCategory}</span>
                </div>
            </div>
            <div className={styles.actions}>
                {!notification.isRead && <span className={styles.dot} style={{ background: color }} />}
                <button className={styles.deleteBtn} onClick={handleDelete} title="Usuń">
                    <FiX size={14} />
                </button>
            </div>
        </div>
    );
};

export default NotificationItem;
